import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SimpleBar from "simplebar-react";
import useCustomFecthQuery from "../../../Hooks/useCustomFecthQuery";
import { detectDeviceType } from "../../../utils/deviceType";
import Header from "./PublicOne/Header";
import About from "./PublicOne/About";
import Sponsors from "./PublicOne/Sponsors";
import OurSpeaker from "./PublicOne/Speakers";
import Faq from "./PublicOne/Faq";
import EventMap from "./PublicOne/EventMap";
import EventPlaceholder from "../../../assets/images/placeholder/EventPplaceholder.png";
import ButtonStyle from "../../Buttons/ButtonSubmit";
import { FaRegCalendar } from "react-icons/fa";
import ButtonGradient from "../../Buttons/ButtonGradient";
import { useTicket } from "../../../context/TicketContext";

const BuyTickets = ({ eventDetails, eventID }) => {
  const Navigate = useNavigate();
  const { updateTicketDetails } = useTicket();
  const obj = JSON.parse(localStorage.getItem("authEventKagoUser"));
  const token = obj?.data?.token;
  const key = ["setTicket", eventID];

  const {
    data: getMyTicketSettings,
    error: errorGetMyTicketSettings,
    isLoading: isLoadingGetMyTicketSettings,
  } = useCustomFecthQuery(
    key,
    `${process.env.REACT_APP_API}ticket-settings/${eventID}/event`,
    token,
    {
      enabled: !!eventID,
    }
  );

  const handleBuyTicket = () => {
    const selectedTickets = (getMyTicketSettings?.data || [])
      .map((ticket) => {
        if (!ticket) return null;
        
        const quantity = quantities[ticket.tier?.toLowerCase()] || 0;
        // Skip tickets with quantity 0
        if (quantity === 0) return null;
        
        const isEarlyBirdActive =
          ticket.allowEarlyBird &&
          today >= new Date(ticket.earlyBirdStartDate) &&
          today <= new Date(ticket.earlyBirdEndDate);

        const ticketPrice = isEarlyBirdActive
          ? ticket?.tierEarlyBirdPrice
          : ticket?.price;

        return {
          tier: ticket.tier,
          quantity: quantity,
          price: ticketPrice,
          total: (ticketPrice || 0) * quantity,
          ticketTerms: ticket.ticketTerms,
          ticketDetail: ticket,
        };
      })
      .filter(Boolean);

    const overallTotal = selectedTickets.reduce((sum, t) => sum + (t?.total || 0), 0);
    console.log(overallTotal)

    const ticketData = {
      tickets: selectedTickets,
      total: overallTotal,
      eventDetails,
    };

    // Update both localStorage and TicketContext
    localStorage.setItem("kagoTicketDetails", JSON.stringify(ticketData));
    updateTicketDetails(ticketData);

    Navigate(`/checkout/${eventID}`);
  };

  const today = new Date();

  const [quantities, setQuantities] = useState({});

  // Initialize quantities based on loaded tickets
  useEffect(() => {
    if (getMyTicketSettings?.data?.length) {
      const initial = {};
      getMyTicketSettings.data.forEach((ticket) => {
        const tier = ticket?.tier?.toLowerCase() || "standard";
        initial[tier] = 0;
      });
      setQuantities(initial);
    }
  }, [getMyTicketSettings?.data]);

  const updateQuantity = (type, increment, ticket) => {
    console.log("ticket...", JSON.stringify(ticket, null, 2));
    setQuantities((prev) => {
      const newValue = Math.max(0, prev[type] + increment);
      if (newValue <= 5) {
        // Max 2 tickets per order
        return { ...prev, [type]: newValue };
      }
      return prev;
    });
  };

  // Calculate subtotal and total

  const getTicketPrice = (ticket) => {
    if (!ticket) return 0;
    
    const earlyBirdActive =
      ticket.allowEarlyBird &&
      today >= new Date(ticket.earlyBirdStartDate) &&
      today <= new Date(ticket.earlyBirdEndDate);

    return Number(
      earlyBirdActive ? ticket.tierEarlyBirdPrice : ticket.price
    );
  };

  const subtotal = (getMyTicketSettings?.data || []).reduce(
    (sum, ticket) => {
      const ticketTier = ticket?.tier?.toLowerCase();
      const qty = quantities[ticketTier] || 0;
      return sum + qty * getTicketPrice(ticket);
    },
    0
  );

  const total = subtotal;

  // Helper function to check if early bird is active
  const isEarlyBirdActive = (ticket) => {
    if (!ticket?.allowEarlyBird) {
      return false;
    }
    
    // Check if dates exist
    if (!ticket?.earlyBirdStartDate || !ticket?.earlyBirdEndDate) {
      return false;
    }
    
    try {
      const earlyBirdStartDate = new Date(ticket.earlyBirdStartDate);
      const earlyBirdEndDate = new Date(ticket.earlyBirdEndDate);
      
      // Validate dates
      if (isNaN(earlyBirdStartDate.getTime()) || isNaN(earlyBirdEndDate.getTime())) {
        return false;
      }
      
      // Set time to start of day for accurate comparison
      const todayStart = new Date(today);
      todayStart.setHours(0, 0, 0, 0);
      
      const startDate = new Date(earlyBirdStartDate);
      startDate.setHours(0, 0, 0, 0);
      
      const endDate = new Date(earlyBirdEndDate);
      endDate.setHours(23, 59, 59, 999);
      
      return todayStart >= startDate && todayStart <= endDate;
    } catch (e) {
      console.error("Error checking early bird dates:", e, ticket);
      return false;
    }
  };

  // Separate tickets into early bird and regular
  const allTickets = getMyTicketSettings?.data || [];
  const earlyBirdTickets = allTickets.filter(isEarlyBirdActive);
  const regularTickets = allTickets.filter((ticket) => !isEarlyBirdActive(ticket));

  // Debug logging
  useEffect(() => {
    if (allTickets.length > 0) {
      console.log("All tickets:", allTickets);
      console.log("Early bird tickets:", earlyBirdTickets);
      console.log("Regular tickets:", regularTickets);
      allTickets.forEach((ticket, idx) => {
        console.log(`Ticket ${idx}:`, {
          tier: ticket.tier,
          allowEarlyBird: ticket.allowEarlyBird,
          earlyBirdStartDate: ticket.earlyBirdStartDate,
          earlyBirdEndDate: ticket.earlyBirdEndDate,
          isActive: isEarlyBirdActive(ticket),
        });
      });
    }
  }, [allTickets.length, earlyBirdTickets.length, regularTickets.length]);

  return (
    <React.Fragment>
      <div
        style={{
          fontFamily: "Arial, sans-serif",
          maxWidth: "50%",
          margin: "0 auto",
          color: "#333",
        }}
      >
        {/* Progress Steps */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            margin: "20px 0 30px",
            fontSize: "14px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span
              style={{
                background:
                  "linear-gradient(to right, rgb(247, 152, 60), rgb(255, 124, 110))",
                color: "white",
                borderRadius: "50%",
                width: "24px",
                height: "24px",
                display: "inline-flex",
                justifyContent: "center",
                alignItems: "center",
                marginRight: "8px",
              }}
            >
              1
            </span>
            <span style={{ color: "#f99145", fontWeight: "500" }}>
              Select Tickets
            </span>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span
              style={{
                backgroundColor: "#E5E7EB",
                color: "#9CA3AF",
                borderRadius: "50%",
                width: "24px",
                height: "24px",
                display: "inline-flex",
                justifyContent: "center",
                alignItems: "center",
                marginRight: "8px",
              }}
            >
              2
            </span>
            <span style={{ color: "#9CA3AF" }}>Payment</span>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span
              style={{
                backgroundColor: "#E5E7EB",
                color: "#9CA3AF",
                borderRadius: "50%",
                width: "24px",
                height: "24px",
                display: "inline-flex",
                justifyContent: "center",
                alignItems: "center",
                marginRight: "8px",
              }}
            >
              3
            </span>
            <span style={{ color: "#9CA3AF" }}>Confirmation</span>
          </div>
        </div>

        {/* Back to Events */}
        <div
          style={{
            margin: "20px 0",
            display: "flex",
            alignItems: "center",
          }}
        >
          <span
            style={{
              color: "#6366F1",
              fontSize: "14px",
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15 18L9 12L15 6"
                stroke="#6366F1"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span style={{ marginLeft: "4px" }}>Back to about event</span>
          </span>
        </div>

        {/* Event Banner */}
        <div
          style={{
            border: "1px solid #E5E7EB",
            borderRadius: "8px",
            overflow: "hidden",
            marginBottom: "24px",
          }}
        >
          <div
            style={{
              height: "180px",
              backgroundColor: "#111",
              // backgroundImage: 'url("/api/placeholder/540/180")',
              backgroundImage:
                'url("https://images.unsplash.com/photo-1540575467063-178a50c2df87?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80")',
              backgroundSize: "cover",
              backgroundPosition: "center",
              position: "relative",
              boxShadow: "0 2px 3px 0 rgb(0 0 0 / .05)",
            }}
          ></div>
          <div
            style={{
              padding: "24px",
              background: "#ffffff",
            }}
          >
            <h2
              style={{
                fontSize: "20px",
                fontWeight: "600",
                margin: "0 0 4px 0",
              }}
            >
              {eventDetails?.eventName}
            </h2>
            <p
              style={{
                color: "#6B7280",
                margin: "0",
                fontSize: "14px",
              }}
            >
              {new Date(eventDetails?.startDate).toLocaleString("default", {
                weekday: "long",
              })}{" "}
              {` ${new Date(eventDetails?.startDate).getDate()}`}{" "}
              {new Date(eventDetails?.startDate).toLocaleString("default", {
                month: "short",
              })}{" "}
              {new Date(eventDetails?.startDate).getFullYear()}
            </p>
          </div>
        </div>

        {/* Select Tickets Header */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "16px",
          }}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3 9C4.65685 9 6 7.65685 6 6C6 4.34315 4.65685 3 3 3V9ZM3 9V15C4.65685 15 6 16.3431 6 18C6 19.6569 4.65685 21 3 21H21C19.3431 21 18 19.6569 18 18C18 16.3431 19.3431 15 21 15V9C19.3431 9 18 7.65685 18 6C18 4.34315 19.3431 3 21 3H3Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>

          <span
            style={{
              marginLeft: "8px",
              fontWeight: "600",
            }}
          >
            Select Tickets
          </span>
        </div>

        {/* Early Bird Tickets Section */}
        {earlyBirdTickets.length > 0 && (
          <div style={{ marginBottom: "24px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "12px",
              }}
            >
              <span
                style={{
                  background:
                    "linear-gradient(to right, rgb(247, 152, 60), rgb(255, 124, 110))",
                  color: "white",
                  padding: "4px 12px",
                  borderRadius: "12px",
                  fontSize: "12px",
                  fontWeight: "600",
                  marginRight: "8px",
                }}
              >
                🎉 EARLY BIRD
              </span>
              <span
                style={{
                  fontSize: "14px",
                  color: "#6B7280",
                  fontWeight: "500",
                }}
              >
                Limited Time Offer
              </span>
            </div>

            {earlyBirdTickets.map((ticket, i) => {
                const earlyBirdStartDate = new Date(ticket.earlyBirdStartDate);
                const earlyBirdEndDate = new Date(ticket.earlyBirdEndDate);
                const closingDate = new Date(ticket.closingDate);
                const isEventClosed = today >= closingDate;
                const isSoldOut = ticket.quantitySold === ticket.quantity;
                const ticketTier = ticket?.tier?.toLowerCase() || "standard";

                return (
                  <div
                    key={`earlybird-${i}`}
                    style={{
                      border: "2px solid",
                      borderImage:
                        "linear-gradient(to right, rgb(247, 152, 60), rgb(255, 124, 110)) 1",
                      backgroundColor: "#FFF9F5",
                      borderRadius: "8px",
                      padding: "24px",
                      marginBottom: "16px",
                      boxShadow: "0 4px 6px 0 rgb(0 0 0 / .1)",
                      position: "relative",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        top: "12px",
                        right: "12px",
                        background:
                          "linear-gradient(to right, rgb(247, 152, 60), rgb(255, 124, 110))",
                        color: "white",
                        padding: "4px 10px",
                        borderRadius: "4px",
                        fontSize: "10px",
                        fontWeight: "600",
                        textTransform: "uppercase",
                      }}
                    >
                      Early Bird
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div style={{ flex: 1 }}>
                        <h3
                          style={{
                            fontSize: "18px",
                            fontWeight: "600",
                            margin: "0 0 4px 0",
                            color: "#1F2937",
                          }}
                        >
                          {ticket.tier || "Standard"}
                        </h3>
                        <p
                          style={{
                            fontSize: "12px",
                            color: "#6B7280",
                            margin: "0 0 8px 0",
                          }}
                        >
                          Early Bird ends{" "}
                          {new Date(ticket.earlyBirdEndDate).toLocaleString(
                            "default",
                            {
                              weekday: "long",
                            }
                          )}{" "}
                          {` ${new Date(ticket.earlyBirdEndDate).getDate()}`}{" "}
                          {new Date(
                            ticket.earlyBirdEndDate
                          ).toLocaleString("default", {
                            month: "short",
                          })}{" "}
                          {new Date(
                            ticket.earlyBirdEndDate
                          ).getFullYear()}
                        </p>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "baseline",
                            gap: "8px",
                            marginBottom: "4px",
                          }}
                        >
                          <p
                            style={{
                              fontSize: "20px",
                              fontWeight: "700",
                              margin: "0",
                              color: "#F97316",
                            }}
                          >
                            R {ticket?.tierEarlyBirdPrice}
                          </p>
                          <p
                            style={{
                              fontSize: "14px",
                              color: "#9CA3AF",
                              margin: "0",
                              textDecoration: "line-through",
                            }}
                          >
                            R {ticket?.price}
                          </p>
                        </div>
                        <p
                          style={{
                            fontSize: "12px",
                            color: "#10B981",
                            margin: "0",
                            fontWeight: "500",
                          }}
                        >
                          Save R {Number(ticket?.price || 0) - Number(ticket?.tierEarlyBirdPrice || 0)}
                        </p>
                        <p
                          style={{
                            fontSize: "12px",
                            color: "#6B7280",
                            margin: "8px 0 0 0",
                          }}
                        >
                          Max 5 tickets per order
                        </p>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginLeft: "16px",
                        }}
                      >
                        <button
                          onClick={() => updateQuantity(ticketTier, -1, ticket)}
                          disabled={isSoldOut || isEventClosed}
                          style={{
                            width: "32px",
                            height: "32px",
                            border: "1px solid #E5E7EB",
                            borderRadius: "4px",
                            background: "white",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor:
                              isSoldOut || isEventClosed
                                ? "not-allowed"
                                : "pointer",
                            opacity: isSoldOut || isEventClosed ? 0.5 : 1,
                          }}
                        >
                          <span style={{ fontSize: "18px" }}>−</span>
                        </button>
                        <input
                          type="text"
                          value={quantities[ticketTier] || 0}
                          readOnly
                          style={{
                            width: "32px",
                            height: "32px",
                            border: "1px solid #E5E7EB",
                            borderRadius: "4px",
                            margin: "0 4px",
                            textAlign: "center",
                            fontSize: "14px",
                          }}
                        />
                        <button
                          onClick={() => updateQuantity(ticketTier, 1, ticket)}
                          disabled={isSoldOut || isEventClosed}
                          style={{
                            width: "32px",
                            height: "32px",
                            border: "1px solid #E5E7EB",
                            borderRadius: "4px",
                            background: "white",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor:
                              isSoldOut || isEventClosed
                                ? "not-allowed"
                                : "pointer",
                            opacity: isSoldOut || isEventClosed ? 0.5 : 1,
                          }}
                        >
                          <span style={{ fontSize: "18px" }}>+</span>
                        </button>
                      </div>
                    </div>
                    {isSoldOut && (
                      <p
                        style={{
                          color: "#EF4444",
                          fontSize: "12px",
                          margin: "12px 0 0 0",
                          fontWeight: "500",
                        }}
                      >
                        Sold Out
                      </p>
                    )}
                    {isEventClosed && !isSoldOut && (
                      <p
                        style={{
                          color: "#EF4444",
                          fontSize: "12px",
                          margin: "12px 0 0 0",
                          fontWeight: "500",
                        }}
                      >
                        Event Closed
                      </p>
                    )}
                  </div>
                );
              })}
          </div>
        )}

        {/* Show message if no tickets */}
        {allTickets.length === 0 && !isLoadingGetMyTicketSettings && (
          <div
            style={{
              padding: "24px",
              textAlign: "center",
              color: "#6B7280",
            }}
          >
            <p>No tickets available for this event.</p>
          </div>
        )}

        {/* Regular Tickets Section - Show all tickets that don't have active early bird */}
        {regularTickets.length > 0 && (
          <div style={{ marginBottom: "16px" }}>
            {earlyBirdTickets.length > 0 && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "16px",
                }}
              >
                <span
                  style={{
                    marginLeft: "8px",
                    fontWeight: "600",
                    fontSize: "16px",
                  }}
                >
                  Regular Tickets
                </span>
              </div>
            )}
            {regularTickets.map((ticket, i) => {
                const closingDate = new Date(ticket.closingDate);
                const isEventClosed = today >= closingDate;
                const isSoldOut = ticket.quantitySold === ticket.quantity;
                const ticketTier = ticket?.tier?.toLowerCase() || "standard";

                return (
                  <div
                    key={`regular-${i}`}
                    style={{
                      border: "1px solid #E5E7EB",
                      backgroundColor: "#ffffff",
                      borderRadius: "8px",
                      padding: "24px",
                      marginBottom: "16px",
                      boxShadow: "0 2px 3px 0 rgb(0 0 0 / .05)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <h3
                          style={{
                            fontSize: "16px",
                            fontWeight: "600",
                            margin: "0 0 4px 0",
                          }}
                        >
                          {ticket.tier || "Standard"}
                        </h3>
                        <p
                          style={{
                            fontSize: "14px",
                            color: "#6B7280",
                            margin: "0 0 8px 0",
                          }}
                        >
                          Closing by{" "}
                          {new Date(ticket.closingDate).toLocaleString(
                            "default",
                            {
                              weekday: "long",
                            }
                          )}{" "}
                          {` ${new Date(ticket.closingDate).getDate()}`}{" "}
                          {new Date(ticket.closingDate).toLocaleString(
                            "default",
                            {
                              month: "short",
                            }
                          )}{" "}
                          {new Date(ticket.closingDate).getFullYear()}
                        </p>
                        <p
                          style={{
                            fontSize: "16px",
                            fontWeight: "600",
                            margin: "0 0 4px 0",
                          }}
                        >
                          R {ticket?.price}
                        </p>
                        <p
                          style={{
                            fontSize: "12px",
                            color: "#6B7280",
                            margin: "0",
                          }}
                        >
                          Max 5 tickets per order
                        </p>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <button
                          onClick={() => updateQuantity(ticketTier, -1, ticket)}
                          disabled={isSoldOut || isEventClosed}
                          style={{
                            width: "32px",
                            height: "32px",
                            border: "1px solid #E5E7EB",
                            borderRadius: "4px",
                            background: "white",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor:
                              isSoldOut || isEventClosed
                                ? "not-allowed"
                                : "pointer",
                            opacity: isSoldOut || isEventClosed ? 0.5 : 1,
                          }}
                        >
                          <span style={{ fontSize: "18px" }}>−</span>
                        </button>
                        <input
                          type="text"
                          value={quantities[ticketTier] || 0}
                          readOnly
                          style={{
                            width: "32px",
                            height: "32px",
                            border: "1px solid #E5E7EB",
                            borderRadius: "4px",
                            margin: "0 4px",
                            textAlign: "center",
                            fontSize: "14px",
                          }}
                        />
                        <button
                          onClick={() => updateQuantity(ticketTier, 1, ticket)}
                          disabled={isSoldOut || isEventClosed}
                          style={{
                            width: "32px",
                            height: "32px",
                            border: "1px solid #E5E7EB",
                            borderRadius: "4px",
                            background: "white",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor:
                              isSoldOut || isEventClosed
                                ? "not-allowed"
                                : "pointer",
                            opacity: isSoldOut || isEventClosed ? 0.5 : 1,
                          }}
                        >
                          <span style={{ fontSize: "18px" }}>+</span>
                        </button>
                      </div>
                    </div>
                    {isSoldOut && (
                      <p
                        style={{
                          color: "#EF4444",
                          fontSize: "12px",
                          margin: "12px 0 0 0",
                          fontWeight: "500",
                        }}
                      >
                        Sold Out
                      </p>
                    )}
                    {isEventClosed && !isSoldOut && (
                      <p
                        style={{
                          color: "#EF4444",
                          fontSize: "12px",
                          margin: "12px 0 0 0",
                          fontWeight: "500",
                        }}
                      >
                        Event Closed
                      </p>
                    )}
                  </div>
                );
              })}
          </div>
        )}
        {/* Subtotal and Total */}
        {getMyTicketSettings?.data.length > 0 && (
          <div
            style={{
              marginBottom: "16px",
              padding: "16px",
              border: "1px solid #E5E7EB",
              backgroundColor: "#ffffff",
              borderRadius: "8px",
              boxShadow: "0 2px 3px 0 rgb(0 0 0 / .05)",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "4px",
              }}
            >
              <span style={{ fontSize: "16px" }}>Subtotal</span>
              <span style={{ fontSize: "16px" }}>R{subtotal.toFixed(2)}</span>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontWeight: "600",
              }}
            >
              <span style={{ fontSize: "16px" }}>Total</span>
              <span style={{ fontSize: "16px" }}>R{total.toFixed(2)}</span>
            </div>

            <button
              style={{
                width: "100%",
                padding: "12px",
                marginTop: "16px",
                background:
                  "linear-gradient(to right, rgb(247, 152, 60), rgb(255, 124, 110))",
                color: "white",
                border: "none",
                borderRadius: "6px",
                fontSize: "16px",
                fontWeight: "500",
                cursor: "pointer",
              }}
              onClick={handleBuyTicket}
            >
              Continue to Payment
            </button>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default BuyTickets;
